import { EncrDecrService } from './EncrDecrService';
import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import firebase from 'firebase/compat/app';
//require('firebase/compat/auth')
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AppFirestoreService, AppFirestoreDocument } from './app-firestore.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { switchMap, startWith, tap, shareReplay, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { User } from '../_core/_interface/user';
import { GoogleAuthProvider, getAuth, signInWithPopup, signOut, signInWithRedirect } from 'firebase/auth';

@Injectable()
export class AuthService {
  public currentUserSubject: BehaviorSubject<User> = new BehaviorSubject<User>(JSON.parse(JSON.stringify(this.encrDecrService.get(localStorage.getItem('user')))));
  public user: Observable<User>;
  constructor(
    public afAuth: AngularFireAuth,
    public afs: AppFirestoreService,
    public router: Router,
    public route: ActivatedRoute,
    public encrDecrService: EncrDecrService
  ) {
    
    if (localStorage.getItem('user')) {
      this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(this.encrDecrService.get(localStorage.getItem('user'))));
      this.user = this.currentUserSubject.asObservable();
    }
    //// Get auth data, then get firestore user document || null
    this.getDetails();
  }
  companyId;
  public getDetails() {
    this.user = this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          return this.afs.doc<User>(`users/${user.uid}`).valueChanges()
            .pipe(map(currentUser => {
              if (currentUser.compId) {
                this.companyId = currentUser.compId;
              }
              localStorage.setItem('user', this.encrDecrService.set(JSON.stringify(currentUser)));
              this.currentUserSubject.next(currentUser);
            }
            ));
        } else {
          return of(null);
        }
      }),
      // Add these lines to set/read the user data to local storage
      tap(),
      startWith(JSON.parse(this.encrDecrService.get(localStorage.getItem('user'))))
    );
  }

  public get currentUserValue(): User {
    if (localStorage.getItem('user')) {
      return (this.currentUserSubject.value);
    }
  }

  ///// Login/Signup //////

  googleLogin() {
    
    return this.oAuthLogin(new GoogleAuthProvider());
// 11/07/2024
    // const provider = new firebase.auth.GoogleAuthProvider();
    // this.afAuth.signInWithRedirect(provider);
  }

  googleLoginClient(item) {
    return this.oAuthLoginClient(new GoogleAuthProvider(), item);
  }

  public oAuthLoginClient(provider, item) {
    const auth = getAuth();
    return signInWithPopup(auth, provider)
      .then((credential) => {
        this.updateUserDataClient(credential.user, item);
      });
  }

  public oAuthLogin(provider) {
    const auth = getAuth();

    return signInWithPopup(auth, provider)
      .then((credential) => {
        this.updateUserData(credential.user);
      });

    // 11/07/2024
      // return signInWithRedirect(auth, provider)
      // .then((credential) => {
      //   this.updateUserData(credential.user);
      // });
  }

  async handleRedirect() {
    try {
      const result = await this.afAuth.getRedirectResult();
      if (result.user) {
        console.log('User signed in:', result.user);
      } else {
        console.log('No user signed in');
      }
    } catch (error) {
      console.error('Error during sign-in with redirect:', error);
    }
  }

  signOut() {
    localStorage.removeItem('user');

    const auth = getAuth();
    signOut(auth).then(() => {
      this.currentUserSubject = new BehaviorSubject<User>(null);
      // this.router.navigate([window.location.href]);
    });
    location.reload();
  }

  public updateUserDataClient(user, item) {
    // Sets user data to firestore on login
    const userRef: AppFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const data: User = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      roles: {
        subscriber: true
      },
      flatUid: item.flatUid,
      building: item.building,
      buildUid: item.buildUid,
      flatNumber: item.flatNumber,
      floor: item.floor,
      projId: item.projId,
      compId: item.compId,
      dateSigningRegForm: item.dateSigningRegForm,
      dateSendingAgreementSale: item.dateSendingAgreementSale,
      dateCompatibleToSign: item.dateCompatibleToSign,
      flatType: item.flatType,
      price: item.price
    };
    return userRef.set(data, { merge: true });
  }

  public updateUserData(user) {
    // Sets user data to firestore on login
    let data: User;
    this.afs.collection('users', ref => ref.where('email', '==', user.email)).valueChanges()
      .subscribe((currentUser: any) => {
        if (currentUser[0]) {
          data = {
            uid: currentUser[0].uid,
            email: currentUser[0].email,
            displayName: currentUser[0].displayName,
            photoURL: currentUser[0].photoURL,
            roles: currentUser[0].roles
          };
        } else {
          data = {
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            photoURL: user.photoURL,
            roles: {
              subscriber: true
            },
          };
        }
        localStorage.setItem('user', this.encrDecrService.set(JSON.stringify(currentUser[0])));
        this.currentUserSubject.next(currentUser[0]);
        const userRef: AppFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
        return userRef.set(data, { merge: true });
      }
      );
  }

  ///// Role-based Authorization //////

  canRead(user: User): boolean {
    const allowed = ['admin', 'editor', 'subscriber'];
    return this.checkAuthorization(user, allowed);
  }

  canEdit(user: User): boolean {
    const allowed = ['admin', 'editor'];
    return this.checkAuthorization(user, allowed);
  }

  canEditCompany(user: User): boolean {
    const allowed = ['admin', 'editor'];
    return this.checkAuthorization(user, allowed);
  }

  canDelete(user: User): boolean {
    const allowed = ['admin', 'editor'];
    return this.checkAuthorization(user, allowed);
  }

  // determines if user has matching role
  public checkAuthorization(user: User, allowedRoles: string[]): boolean {
    if (!user) { return false; }
    for (const role of allowedRoles) {
      if (user.roles[role]) {
        return true;
      }
    }
    return false;
  }
}

